Vendd.Scripts.load(function () {
    var $wrapper = $('.x-login-widget');
    var model = null;

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    wrapper.open = function () {
        $(".js-widget-trigger", $wrapper).addClass('x-open');
        $(".js-widget-container", $wrapper).addClass('x-expanded').show();

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.LoginWidget));
    };

    wrapper.close = function () {
        $(".js-widget-trigger", $wrapper).removeClass('x-open');
        $(".js-widget-container", $wrapper).removeClass('x-expanded').hide();
    };

    wrapper.showLoader = function () {

        $wrapper.addClass('x-loading');
    };

    wrapper.hideLoader = function () {

        $wrapper.removeClass('x-loading');
    };

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("loginWidget", model);
        $wrapper.html(html);

        $(".js-widget-container", $wrapper).bind('mousewheel DOMMouseScroll', function (e) {
            var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;

            this.scrollTop += (delta < 0 ? 1 : -1) * 30;
            e.preventDefault();
        });

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));
    };

    $wrapper.on('click', '.js-logout', function (e) {
        e.preventDefault();

        Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
    });

    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('x-open')) {

            if ($('html, body').hasClass('no-scroll')) {
                $('html, body').removeClass('no-scroll');
            }
            wrapper.close();

        } else {

            if ($(window).width() < 768) {
                $('html, body').addClass('no-scroll');
            }
            wrapper.open();

        }
    });

    $wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', function (e) {
        wrapper.close();
    });

    //Validation for class no scroll on resize
    $(window).resize(_.debounce(function () {
        if ($(window).width() > 767 && $('.js-widget-trigger', $wrapper).hasClass('x-open')) {
            $('html, body').removeClass('no-scroll');
        } else if ($(window).width() < 768 && $('.js-widget-trigger', $wrapper).hasClass('x-open')) {
            $('html, body').addClass('no-scroll');
        }

    }, 50));


    Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, wrapper, function (envelope) {
        if (envelope.message.data.success) {
            Vendd.MessageBus.publish(wrapper, new Vendd.User.Messages.GetUserViewModel());
        };
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.LoginWidget) {
            wrapper.close();
        };
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;
        wrapper.update();
    });

});